import p1 from "../images/photography/IMG_1271.JPG";
import p2 from "../images/photography/IMG_0808.jpg";
import p3 from "../images/photography/IMG_5041.JPG";
import p4 from "../images/photography/IMG_3365.JPG";
import p5 from "../images/photography/IMG_4046.jpg";
import p6 from "../images/photography/IMG_3598.jpg";
import p7 from "../images/photography/IMG_5064.JPG";
import p8 from "../images/photography/IMG_4547.jpg";
import p9 from "../images/photography/IMG_3552.jpg";
import p10 from "../images/photography/IMG_0965.JPG";
import p11 from "../images/photography/IMG_5060.JPG";
import p12 from "../images/photography/IMG_0597.jpg";
import p13 from "../images/photography/IMG_0524.jpg";
import p14 from "../images/photography/IMG_4454.JPG";
import p15 from "../images/photography/IMG_0064.JPG";
import p16 from "../images/photography/IMG_0095.JPG";
import p17 from "../images/photography/IMG_5061.JPG";
import p18 from "../images/photography/IMG_5101.jpg";
import p19 from "../images/photography/IMG_0001.JPG";
import p20 from "../images/photography/IMG_3834.jpg";
import p21 from "../images/photography/IMG_0013.JPG";
import p22 from "../images/photography/IMG_6845.JPG";
import p23 from "../images/photography/IMG_2572.JPG";
import p24 from "../images/photography/IMG_3594.jpg";
import p25 from "../images/photography/IMG_5042.JPG";
import p26 from "../images/photography/IMG_4408.JPG";
import p27 from "../images/photography/IMG_3467.jpg";
import p28 from "../images/photography/IMG_1160.jpeg";
import p29 from "../images/photography/IMG_1852.jpg";
import p30 from "../images/photography/IMG_3876.jpg";
import p31 from "../images/photography/IMG_8327.JPG";
import p32 from "../images/photography/IMG_4649.jpg";
import p33 from "../images/photography/IMG_4833.jpg";
import p34 from "../images/photography/IMG_3682.jpg";
import p35 from "../images/photography/IMG_1480.PNG";
import p36 from "../images/photography/IMG_3699.jpg";
import p37 from "../images/photography/IMG_8521.JPG";
import p38 from "../images/photography/IMG_3403.JPG";
import p39 from "../images/photography/IMG_3230.JPG";
import p40 from "../images/photography/IMG_3704.jpg";
import p41 from "../images/photography/IMG_2591.JPG";
import p42 from "../images/photography/IMG_4580.jpg";
import p43 from "../images/photography/IMG_0862.JPG";
import p44 from "../images/photography/IMG_0726.jpg";
import p45 from "../images/photography/IMG_4344.jpg";
import p46 from "../images/photography/IMG_0081.JPG";
import p47 from "../images/photography/IMG_5063.JPG";
import p48 from "../images/photography/IMG_3844.PNG";
import p49 from "../images/photography/IMG_1736.jpg";
import p50 from "../images/photography/IMG_4438.JPG";
import p51 from "../images/photography/IMG_8363.JPG";
import p52 from "../images/photography/IMG_8366.JPG";
import p53 from "../images/photography/IMG_0854.jpg";
import p54 from "../images/photography/IMG_2389.JPG";
import p55 from "../images/photography/IMG_0061.JPG";
import p56 from "../images/photography/IMG_7128.JPG";
import p57 from "../images/photography/IMG_4155.JPG";
import p58 from "../images/photography/IMG_2208.jpg";
import p59 from "../images/photography/IMG_3843.JPG";
import p60 from "../images/photography/IMG_8604.JPG";
import p61 from "../images/photography/IMG_1688.jpg";
import p62 from "../images/photography/IMG_2226.jpeg";
import p63 from "../images/photography/IMG_4559.jpg";
import p64 from "../images/photography/IMG_4732.jpg";
import p65 from "../images/photography/IMG_4459.JPG";
import p66 from "../images/photography/IMG_0963.jpg";
import p67 from "../images/photography/IMG_4429.JPG";
import p68 from "../images/photography/IMG_3133.jpg";
import p69 from "../images/photography/IMG_9883.JPG";
import p70 from "../images/photography/IMG_5047.JPG";
import p71 from "../images/photography/IMG_4349.jpg";
import p72 from "../images/photography/IMG_2045.jpg";
import p73 from "../images/photography/IMG_8464.JPG";
import p74 from "../images/photography/IMG_3911.jpg";
import p75 from "../images/photography/IMG_5050.JPG";
import p76 from "../images/photography/IMG_4107.jpg";
import p77 from "../images/photography/IMG_1176.jpg";
import p78 from "../images/photography/IMG_4434.JPG";
import p79 from "../images/photography/IMG_1881.jpg";
import p80 from "../images/photography/IMG_4909.jpg";
import p81 from "../images/photography/IMG_3238.JPG";
import p82 from "../images/photography/IMG_1643.jpg";
import p83 from "../images/photography/IMG_2638.JPG";
import p84 from "../images/photography/IMG_0060.JPG";
import p85 from "../images/photography/IMG_3435.JPG";
import p86 from "../images/photography/IMG_1478.JPG";
import p87 from "../images/photography/IMG_2798.jpg";
import p88 from "../images/photography/IMG_8247.JPG";
import p89 from "../images/photography/IMG_5071.JPG";
import p90 from "../images/photography/IMG_2854.jpg";
import p91 from "../images/photography/IMG_3990.jpg";
import p92 from "../images/photography/IMG_4724.jpg";
import p93 from "../images/photography/IMG_0094.JPG";

const photo_dict = [
  {
    "src": p1, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p2, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p3, 
    "width": 1.0, 
    "height": 0.6666666666666666
  }, {
    "src": p4, 
    "width": 1.0, 
    "height": 0.39772138788192646
  }, {
    "src": p5, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p6, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p7, 
    "width": 1.0, 
    "height": 0.40894568690095845
  }, {
    "src": p8, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p9, 
    "width": 0.9208655332302936, 
    "height": 1.0
  }, {
    "src": p10, 
    "width": 1.0, 
    "height": 0.5615942028985508
  }, {
    "src": p11, 
    "width": 1.0, 
    "height": 0.6666666666666666
  }, {
    "src": p12, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p13, 
    "width": 0.75, 
    "height": 1.0
  }, {
    "src": p14,
    "width": 1.0, 
    "height": 0.6666666666666666
  }, {
    "src": p15,
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p16, 
    "width": 0.8420186505759737, 
    "height": 1.0
  }, {
    "src": p17, 
    "width": 1.0, 
    "height": 0.6666666666666666
  }, {
    "src": p18, 
    "width": 0.75, 
    "height": 1.0
  }, {
    "src": p19, 
    "width": 0.8088813940415964, 
    "height": 1.0
  }, {
    "src": p20, 
    "width": 0.791005291005291, 
    "height": 1.0
  }, {
    "src": p21, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p22, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p23, 
    "width": 0.75, 
    "height": 1.0
  }, {
    "src": p24, 
    "width": 0.851830985915493, 
    "height": 1.0
  }, {
    "src": p25, 
    "width": 1.0, 
    "height": 0.6666666666666666
  }, {
    "src": p26, 
    "width": 1.0, 
    "height": 0.7462235649546828
  }, {
    "src": p27, 
    "width": 1.0, 
    "height": 0.47791563275434246
  }, {
    "src": p28, 
    "width": 0.75, 
    "height": 1.0
  }, {
    "src": p29, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p30, 
    "width": 1.0, 
    "height": 0.7662116040955631
  }, {
    "src": p31, 
    "width": 0.75, 
    "height": 1.0
  }, {
    "src": p32, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p33, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p34, 
    "width": 0.75, 
    "height": 1.0
  }, {
    "src": p35, 
    "width": 0.8161044613710555, 
    "height": 1.0
  }, {
    "src": p36, 
    "width": 0.7875647668393783, 
    "height": 1.0
  }, {
    "src": p37, 
    "width": 1.0, 
    "height": 0.6410738255033557
  }, {
    "src": p38, 
    "width": 0.5258473125641904, 
    "height": 1.0
  }, {
    "src": p39, 
    "width": 1.0, 
    "height": 0.4333821376281113
  }, {
    "src": p40, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p41, 
    "width": 1.0, 
    "height": 0.7501220107369448
  }, {
    "src": p42, 
    "width": 0.75, 
    "height": 1.0
  }, {
    "src": p43, 
    "width": 1.0, 
    "height": 0.6629261976694001
  }, {
    "src": p44, 
    "width": 0.75, 
    "height": 1.0
  }, {
    "src": p45, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p46, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p47, 
    "width": 1.0, 
    "height": 0.4646098003629764
  }, {
    "src": p48, 
    "width": 0.9866666666666667, 
    "height": 1.0
  }, {
    "src": p50, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p51, 
    "width": 1.0, 
    "height": 0.6666666666666666
  }, {
    "src": p52, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p53, 
    "width": 1.0, 
    "height": 0.9551724137931035
  }, {
    "src": p54, 
    "width": 0.75, 
    "height": 1.0
  }, {
    "src": p55, 
    "width": 1.0, 
    "height": 0.7501220107369448
  }, {
    "src": p56, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p57, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p58, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p59, 
    "width": 0.9813333333333333, 
    "height": 1.0
  }, {
    "src": p60, 
    "width": 1.0, 
    "height": 0.699156746031746
  }, {
    "src": p61, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p62, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p63, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p64,
    "width": 0.75, 
    "height": 1.0
  }, {
    "src": p65, 
    "width": 1.0, 
    "height": 0.6666666666666666
  }, {
    "src": p66,
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p67, 
    "width": 1.0, 
    "height": 0.6666666666666666
  }, {
    "src": p68, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p69, 
    "width": 0.75, 
    "height": 1.0
  }, {
    "src": p70, 
    "width": 1.0, 
    "height": 0.6666666666666666
  }, {
    "src": p71, 
    "width": 0.75, 
    "height": 1.0
  }, {
    "src": p72, 
    "width": 0.8423398328690808, 
    "height": 1.0
  }, {
    "src": p73, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p74, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p75, 
    "width": 1.0, 
    "height": 0.6666666666666666
  }, {
    "src": p76, 
    "width": 0.5974187143211716, 
    "height": 1.0
  }, {
    "src": p77, 
    "width": 1.0, 
    "height": 0.7142857142857143
  }, {
    "src": p78, 
    "width": 0.6666666666666666, 
    "height": 1.0
  }, {
    "src": p79, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p80, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p81, 
    "width": 1.0,
    "height": 0.4512338425381904
  }, {
    "src": p82, 
    "width": 1.0,
    "height": 0.7700787401574803
  }, {
    "src": p83, 
    "width": 1.0,
    "height": 0.6666666666666666
  }, {
    "src": p84, 
    "width": 1.0,
    "height": 0.3914050437467833
  }, {
    "src": p85, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p86, 
    "width": 1.0, 
    "height": 0.37817028985507245
  }, {
    "src": p87, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p88, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p89, 
    "width": 1.0, 
    "height": 0.6666666666666666
  }, {
    "src": p90, 
    "width": 1.0, 
    "height": 0.75
  }, {
    "src": p91, 
    "width": 1.0, 
    "height": 0.4890818858560794
  }, {
    "src": p92, 
    "width": 0.75, 
    "height": 1.0
  }, {
    "src": p93, 
    "width": 1.0, 
    "height": 0.8722238246322469
  }
];

const photo_project = {
  title: 'Photography',
  description: 'Things I saw that I wanted to remember.',

  sections: [],
  photoAlbum: photo_dict,
};

export default photo_project;
